import {Action, Dispatch} from 'redux';
import {CreateCoverNote, Identity, InsurerId, SortBy, UpdateDocument, VoidDocument} from '../../Config/dataModel';
import coverNoteAPI from '../APIs/coverNoteAPI';

const TYPES = {
    FETCH_ALL_COVER_NOTES_SUCCESS: 'FETCH_ALL_COVER_NOTES_SUCCESS',
    FETCH_ALL_ARCHIVED_SUCCESS: 'FETCH_ALL_ARCHIVED_SUCCESS',
    FETCH_COVER_NOTE_SUCCESS: 'FETCH_COVER_NOTE_SUCCESS',
    FETCH_COVER_NOTE_COUNT_SUCCESS: 'FETCH_COVER_NOTE_COUNT_SUCCESS',
    FETCH_ARCHIVED_COUNT_SUCCESS: 'FETCH_ARCHIVED_COUNT_SUCCESS',
    SA_APPLY_COVER_NOTE_SUCCESS: 'SA_APPLY_COVER_NOTE_SUCCESS',
    IN_APPLY_COVER_NOTE_SUCCESS: 'IN_APPLY_COVER_NOTE_SUCCESS',
    IN_CONFIRM_COVER_NOTE_SUCCESS: 'IN_CONFIRM_COVER_NOTE_SUCCESS',
    UPDATE_COVER_NOTE_SUCCESS: 'UPDATE_COVER_NOTE_SUCCESS',
    VOID_COVER_NOTE_SUCCESS: 'VOID_COVER_NOTE_SUCCESS',
    FETCH_COVER_NOTE_HISTORY_SUCCESS: 'FETCH_COVER_NOTE_HISTORY_SUCCESS',
};

const fetchAllCoverNotes = (data: SortBy) => {
    return function (dispatch: Dispatch<Action>) {
        return coverNoteAPI.allCoverNotes(data).then(res => {
            dispatch(storeAllCoverNotes(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchAllArchived = (data: SortBy) => {
    return function (dispatch: Dispatch<Action>) {
        return coverNoteAPI.allArchived(data).then(res => {
            dispatch(storeAllArchived(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchCoverNote = (ref: string, data: InsurerId) => {
    return function (dispatch: Dispatch<Action>) {
        return coverNoteAPI.coverNote(ref, data).then(res => {
            dispatch(storeCoverNote(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchCoverNoteCount = (data: InsurerId) => {
    return function (dispatch: Dispatch<Action>) {
        return coverNoteAPI.coverNoteCount(data).then(res => {
            dispatch(storeCoverNoteCount(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchArchivedCount = (data: InsurerId) => {
    return function (dispatch: Dispatch<Action>) {
        return coverNoteAPI.archivedCount(data).then(res => {
            dispatch(storeArchivedCount(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const subAgentApplyCN = (data: CreateCoverNote) => {
    return function (dispatch: Dispatch<Action>) {
        return coverNoteAPI.subAgentApplyCN(data).then(res => {
            dispatch(storeSubAgentApplyCNStatus(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const insurerApplyCN = (data: CreateCoverNote) => {
    return function (dispatch: Dispatch<Action>) {
        return coverNoteAPI.insurerApplyCN(data).then(res => {
            dispatch(storeInsurerApplyCNStatus(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const insurerConfirmCN = (ref: string, data: Identity) => {
    return function (dispatch: Dispatch<Action>) {
        return coverNoteAPI.insurerConfirmCN(ref, data).then(res => {
            dispatch(storeInsurerConfirmCNStatus(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const updateCoverNote = (ref: string, data: UpdateDocument) => {
    return function (dispatch: Dispatch<Action>) {
        return coverNoteAPI.updateCoverNote(ref, data).then(res => {
            dispatch(storeUpdateCNStatus(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const voidCoverNote = (ref: string, data: VoidDocument) => {
    return function (dispatch: Dispatch<Action>) {
        return coverNoteAPI.voidCoverNote(ref, data).then(res => {
            dispatch(storeVoidCNStatus(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchCoverNoteHistory = (ref: string, data: InsurerId) => {
    return function (dispatch: Dispatch<Action>) {
        return coverNoteAPI.coverNoteHistory(ref, data).then(res => {
            dispatch(storeCoverNoteHistory(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const storeAllCoverNotes = (data: object) => {
    return {
        type: TYPES.FETCH_ALL_COVER_NOTES_SUCCESS,
        allCoverNotes: data
    };
};

const storeAllArchived = (data: object) => {
    return {
        type: TYPES.FETCH_ALL_ARCHIVED_SUCCESS,
        allArchived: data
    };
};

const storeCoverNote = (data: object) => {
    return {
        type: TYPES.FETCH_COVER_NOTE_SUCCESS,
        coverNote: data
    };
};

const storeCoverNoteCount = (data: object) => {
    return {
        type: TYPES.FETCH_COVER_NOTE_COUNT_SUCCESS,
        coverNoteCount: data
    };
};

const storeArchivedCount = (data: object) => {
    return {
        type: TYPES.FETCH_ARCHIVED_COUNT_SUCCESS,
        archivedCount: data
    };
};

const storeSubAgentApplyCNStatus = (data: object) => {
    return {
        type: TYPES.SA_APPLY_COVER_NOTE_SUCCESS,
        cnSummary: data
    };
};

const storeInsurerApplyCNStatus = (data: object) => {
    return {
        type: TYPES.IN_APPLY_COVER_NOTE_SUCCESS,
        cnSummary: data
    };
};

const storeInsurerConfirmCNStatus = (data: object) => {
    return {
        type: TYPES.IN_CONFIRM_COVER_NOTE_SUCCESS,
        confirmCnSummary: data
    };
};

const storeUpdateCNStatus = (data: object) => {
    return {
        type: TYPES.UPDATE_COVER_NOTE_SUCCESS,
        cnSummary: data
    };
};

const storeVoidCNStatus = (data: object) => {
    return {
        type: TYPES.VOID_COVER_NOTE_SUCCESS,
        voidCnSummary: data
    };
};

const storeCoverNoteHistory = (data: object) => {
    return {
        type: TYPES.FETCH_COVER_NOTE_HISTORY_SUCCESS,
        coverNoteHistory: data
    };
};

export {
    TYPES,
    fetchAllCoverNotes,
    fetchAllArchived,
    fetchCoverNote,
    fetchCoverNoteCount,
    fetchArchivedCount,
    subAgentApplyCN,
    insurerApplyCN,
    insurerConfirmCN,
    updateCoverNote,
    voidCoverNote,
    fetchCoverNoteHistory
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/Actions/coverNoteAction.ts